import { HStack, Text } from '@genial/components';
import React from 'react';

interface AccountRowProps {
  custodyAccountNormalized: string;
  sinacorAccountNormalized: string;
  isSelected?: boolean;
}

export const AccountRow: React.FC<AccountRowProps> = ({
  custodyAccountNormalized,
  sinacorAccountNormalized,
  isSelected,
}) => {
  return (
    <HStack alignItems="center" space="inline.nano" flex={1}>
      <HStack flex={1}>
        <Text variant={isSelected ? 'semibold' : 'regular'} color="neutral.black" numberOfLines={1}>
          {custodyAccountNormalized}
        </Text>
      </HStack>
      <HStack flex={1} justifyContent="flex-end">
        <Text
          variant={isSelected ? 'semibold' : 'regular'}
          color="neutral.medium"
          numberOfLines={1}>
          {sinacorAccountNormalized}
        </Text>
      </HStack>
    </HStack>
  );
};
